// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"f2e99401","357":"3f83f314","360":"a324330a","407":"2d86d153","757":"a35a335c","904":"d8a99b21"}[chunkId] + ".chunk.js";
};